// src/pages/HomePage.jsx
import React from 'react'
import About from '../components/About/About'
import Certifications from '../components/Certifications/Certifications'
import Projects from '../components/Projects/Projects'
import Skills from '../components/Skills/Skills'
import Contact from '../components/Contact/Contact'
export default function HomePage() {
  return (
    <>
      <About />
      <Certifications />
      <Projects />
      <Skills />
      <Contact/>
    </>
  )
}